export default "__VITE_ASSET__d5ee762b__"